import { datadogLogs } from '@datadog/browser-logs';

const STORAGE_KEY = 'VoiceEnhancement';

export const NOISE_SUPPRESSION_ON: connect.VoiceEnhancementMode = 'NOISE_SUPPRESSION';
export const NOISE_SUPPRESSION_OFF: connect.VoiceEnhancementMode = 'NONE';

/** Returns the agent's saved preference, or undefined when they never chose one. */
export const getSavedNoiseSuppression = (): boolean | undefined => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === null ? undefined : saved === 'true';
  } catch {
    return undefined;
  }
};

export const saveNoiseSuppression = (enabled: boolean): void => {
  try {
    localStorage.setItem(STORAGE_KEY, String(enabled));
  } catch {
    // Storage can be unavailable (private mode, blocked site data); the setting then just isn't remembered.
  }
};

/** Re-applies the saved preference to the agent when the agent is not already in the exact mode it implies. */
export const restoreNoiseSuppression = (agent: connect.Agent): void => {
  const saved = getSavedNoiseSuppression();
  if (saved === undefined) return;

  try {
    const desiredMode = saved ? NOISE_SUPPRESSION_ON : NOISE_SUPPRESSION_OFF;
    if (agent.getVoiceEnhancementMode() === desiredMode) return;

    agent
      .setVoiceEnhancementMode(desiredMode)
      .catch((err: Error) =>
        datadogLogs.logger.error('Unable to restore voice enhancement mode', { voiceEnhancement: true }, err)
      );
  } catch (err) {
    datadogLogs.logger.warn('Unable to restore voice enhancement mode', { voiceEnhancement: true }, err as Error);
  }
};
